"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkForm = exports.LinkFormProperty = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _vue = _interopRequireDefault(require("vue"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _formApi = require("../apis/formApi");

var _vueJsonView = require("vue-json-view");

var _dec, _class, _class2, _descriptor, _temp, _dec2, _class4, _class5, _descriptor2, _temp2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var state = _vue.default.observable({
  formList: [],
  formLoad: false,
  formField: {}
});

function getFormList() {
  if (!state.formLoad) {
    _formApi.FormApi.getAllFormList().then(function (list) {
      state.formList = list;
    });
  }
}

function getFieldList(formId) {
  _formApi.FormApi.getForm(formId).then(function (form) {
    var list = form.children && form.children.map(function (child) {
      if (child.tag === 'mh-form-item') {
        return _objectSpread({
          label: child._lang && child._lang.zh && child._lang.zh.label,
          value: child.name
        }, child);
      }
    }).filter(function (child) {
      return !!child;
    });

    _vue.default.set(state.formField, formId, list);
  });
}

var LinkFormProperty = (_dec = (0, _vuePropertyDecorator.Model)(), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_VueComponent) {
  (0, _inherits2.default)(LinkFormProperty, _VueComponent);

  var _super = _createSuper(LinkFormProperty);

  function LinkFormProperty() {
    var _this;

    (0, _classCallCheck2.default)(this, LinkFormProperty);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "value", _descriptor, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LinkFormProperty, [{
    key: "fieldList",
    get: function get() {
      var _this$value = this.value,
          value = _this$value === void 0 ? {} : _this$value;
      var result = state.formField[value.formId];

      if (!result && value.formId) {
        getFieldList(value.formId);
      }

      if (result) {
        return [{
          label: '主键',
          value: '_id'
        }].concat((0, _toConsumableArray2.default)(result));
      }

      return [];
    }
  }, {
    key: "showFields",
    get: function get() {
      var _this$value2 = this.value,
          value = _this$value2 === void 0 ? {} : _this$value2;
      return value.showFields && value.showFields.map(function (field) {
        return field.value;
      }) || [];
    }
  }, {
    key: "created",
    value: function created() {
      getFormList();
    }
  }, {
    key: "linkFormIdChange",
    value: function linkFormIdChange(formId) {
      getFieldList(formId);
      this.$emit('change', {
        formId: formId
      });
    }
  }, {
    key: "showFieldChange",
    value: function showFieldChange() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$value3 = this.value,
          value = _this$value3 === void 0 ? {} : _this$value3,
          fieldList = this.fieldList;
      var showFields = fieldList.filter(function (field) {
        return fields.includes(field.value);
      });
      this.$emit('change', _objectSpread(_objectSpread({}, value), {}, {
        showFields: showFields
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var h = arguments[0];
      var _this$value4 = this.value,
          value = _this$value4 === void 0 ? {} : _this$value4,
          linkFormIdChange = this.linkFormIdChange,
          fieldList = this.fieldList,
          showFields = this.showFields,
          showFieldChange = this.showFieldChange;
      return h("div", {
        "class": "link-form-property",
        "style": "margin: -8px 0 -32px;"
      }, [h("div", {
        "class": "mh-form-item"
      }, [h("div", {
        "class": "mh-form-item-label"
      }, [h("label", ["\u5173\u8054\u8868\u5355"])]), h("div", {
        "class": "mh-form-item-control-wrapper"
      }, [h("a-select", {
        "attrs": {
          "allowClear": true,
          "options": state.formList,
          "value": value.formId
        },
        "on": {
          "change": linkFormIdChange
        }
      })])]), h("div", {
        "class": "mh-form-item"
      }, [h("div", {
        "class": "mh-form-item-label"
      }, [h("label", ["\u641C\u7D22\u5B57\u6BB5"])]), h("div", {
        "class": "mh-form-item-control-wrapper"
      }, [h("a-select", {
        "attrs": {
          "allowClear": true,
          "options": fieldList,
          "mode": "multiple",
          "value": value.searchFields
        },
        "on": {
          "change": function change(fields) {
            return _this2.$emit('change', _objectSpread(_objectSpread({}, value), {}, {
              searchFields: fields
            }));
          }
        }
      })])]), h("div", {
        "class": "mh-form-item"
      }, [h("div", {
        "class": "mh-form-item-label"
      }, [h("label", ["\u5C55\u793A\u5B57\u6BB5"])]), h("div", {
        "class": "mh-form-item-control-wrapper"
      }, [h("a-select", {
        "attrs": {
          "allowClear": true,
          "options": fieldList,
          "mode": "multiple",
          "value": showFields
        },
        "on": {
          "change": showFieldChange
        }
      })])])]);
    }
  }]);
  return LinkFormProperty;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.LinkFormProperty = LinkFormProperty;
var LinkForm = (_dec2 = (0, _vuePropertyDecorator.Prop)(), (0, _vuePropertyDecorator.Component)(_class4 = (_class5 = (_temp2 = /*#__PURE__*/function (_VueComponent2) {
  (0, _inherits2.default)(LinkForm, _VueComponent2);

  var _super2 = _createSuper(LinkForm);

  function LinkForm() {
    var _this3;

    (0, _classCallCheck2.default)(this, LinkForm);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this3, "link", _descriptor2, (0, _assertThisInitialized2.default)(_this3));
    return _this3;
  }

  (0, _createClass2.default)(LinkForm, [{
    key: "render",
    value: function render(h) {
      var showFields = this.link && this.link.showFields || [];
      return h("div", {
        "class": "link-form"
      }, [h("mh-form-item", {
        "props": _objectSpread({}, _objectSpread({}, this.$attrs))
      }, [h("mh-select", {
        "attrs": {
          "type": '"searchLabelValue"',
          "link": this.link
        }
      })]), showFields.map(function (field) {
        return _vueJsonView.VueJsonView.ele2VNode(h, _objectSpread(_objectSpread({}, field), {}, {
          key: field.name
        }));
      })]);
    }
  }]);
  return LinkForm;
}(_vuePropertyDecorator.Vue), _temp2), (_descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class5.prototype, "link", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5)) || _class4);
exports.LinkForm = LinkForm;